import { sentenceCase } from "../../../constants";
import { UBRadioBox } from "../../../Libraries";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../config/firebase";

function SortFilterContent({ options = [], selectedValue, onSelect }) {

  return (
    <div className={styles.popoverContent}>
      <ul className={styles.checkboxList}>
        {options.map((opt) => {
          const isSelected = (Array.isArray(selectedValue) ? selectedValue[0] : selectedValue) === opt.value;
          return (
            <li
              key={opt.value}
              role="option"
              aria-selected={isSelected}
              className={styles.checkboxItem}
              onClick={() => {
                triggerLogEvent(analytics, "sort_option_selected", { sort_value: opt.value });
                onSelect?.(opt.value);
              }}
            >
              <UBRadioBox
                label={opt.label}
                onChange={() => { }}
                value={selectedValue}
                checked={isSelected}
                isLabelStatic={opt.label === "POS" || /\([A-Z]\s*[-–]\s*[A-Z]\)/.test(opt.label) || /^[A-Z]{2,}/.test(opt.label)}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default SortFilterContent;
